import { isSubmitComplete } from "@pathwright/blocks-core/src/blocks/submit/block-type"
import {
  BLOCK_INPUT_STATES,
  useBlockCompletion,
  useBlocksConfig,
  useSyncer
} from "@pathwright/blocks-engine"
import { MEDIA_TYPES } from "@pathwright/ux/src/components/filestack/constants"
import PropTypes from "prop-types"
import React from "react"
import { SubmitInnerUI, SubmitViewWrapper } from "../ui"
import { fileToSubmission, linkToSubmission } from "../utils"
import Submissions from "./Submissions"
import SubmitPrompt from "./SubmitPrompt"

export const SubmitView = ({ data, onChange, id }) => {
  const { submission, submissions = [], allowedType, submitPrompt } = data

  const files = submission ? [submission] : submissions

  const { theme, disableInput } = useBlocksConfig()
  const { blocksContext } = useSyncer()

  const { setBlockFunctions, setUseAutocomplete, getBlurProps } =
    useBlockCompletion()

  React.useEffect(() => {
    setUseAutocomplete(true)
    setBlockFunctions({
      validateInput,
      getBlockIsCompleted
    })
  }, [])

  const validateInput = (data) =>
    isSubmitComplete(data) ? BLOCK_INPUT_STATES.VALID : BLOCK_INPUT_STATES.NONE

  const getBlockIsCompleted = (data) => isSubmitComplete(data)

  const handleAddFiles = (nextFiles, isLink = false) => {
    const nextSubmissions = nextFiles.map((file) =>
      isLink ? linkToSubmission(file) : fileToSubmission(file)
    )
    onChange(
      {
        submissions: [...files].concat(nextSubmissions)
      },
      true
    )
  }

  const handleRemoveFile = ({ url }) => {
    onChange(
      {
        submissions: files.filter((file) => file.url !== url),
        // Handle legacy single file submission
        submission: null
      },
      true
    )
  }

  const handleUpdateFile = (updatedFile) => {
    const nextFiles = files.map((file) => {
      if (file.id === updatedFile.id) return updatedFile
      return file
    })
    onChange(
      {
        submissions: nextFiles
      },
      true
    )
  }

  return (
    <SubmitViewWrapper className="SubmitView" {...getBlurProps()}>
      <SubmitInnerUI disableInput={disableInput}>
        <SubmitPrompt mediaType={allowedType} submitPrompt={submitPrompt} />
        <Submissions
          files={files}
          mediaStoragePath={blocksContext?.mediaStoragePath}
          theme={theme}
          mediaType={allowedType || MEDIA_TYPES.ANY}
          onAddFiles={handleAddFiles}
          onRemoveFile={handleRemoveFile}
          onUpdateFile={handleUpdateFile}
          disableChanges={disableInput}
          blockID={id}
        />
      </SubmitInnerUI>
    </SubmitViewWrapper>
  )
}

SubmitView.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.object.isRequired,
  layout: PropTypes.string.isRequired
}

export default SubmitView
